module.exports = __webpack_public_path__ + "img/tk.f2c3a640.svg";